import React, { useState } from "react";
import { Row, Col, Badge } from "react-bootstrap";
import DataTable from "../../table/DataTable";

// Import images
import bill100 from "../../../../images/cash/100_dollar.png";
import bill50 from "../../../../images/cash/50_dollar.png";
import bill10 from "../../../../images/cash/10_dollar.png";
import bill5 from "../../../../images/cash/5_dollar.png";

const EnterDenominations = ({ customer }) => {
  const [quantities, setQuantities] = useState({});

  const denominations = [
    { id: "bill1000", label: "1000 Dollars", value: 1000, inventory: 101, image: bill100 },
    { id: "bill100", label: "100 Dollars", value: 100, inventory: 100, image: bill100 },
    { id: "bill50", label: "50 Dollars", value: 50, inventory: 9, image: bill50 },
    { id: "bill10", label: "10 Dollars", value: 10, inventory: 1, image: bill10 },
    { id: "bill5", label: "5 Dollars", value: 5, inventory: 1, image: bill5 },
    { id: "bill2", label: "2 Dollars", value: 2, inventory: 1, image: bill10 }, // Reusing image
    { id: "bill1", label: "1 Dollar", value: 1, inventory: 50, image: bill5 }, // Reusing image
    { id: "coin50c", label: "50 Cents", value: 0.5, inventory: "-" },
    { id: "coin20c", label: "20 Cents", value: 0.2, inventory: "-" },
    { id: "coin10c", label: "10 Cents", value: 0.1, inventory: "-" },
    { id: "coin5c", label: "5 Cents", value: 0.05, inventory: "-" },
  ];

  const handleQuantityChange = (id, val) => {
    const value = Math.max(0, parseInt(val) || 0);
    setQuantities({ ...quantities, [id]: value });
  };

  const totalTopUp = denominations.reduce((sum, item) => {
    return sum + item.value * (quantities[item.id] || 0);
  }, 0);

  const columns = [
    {
      label: "IMAGE",
      key: "image",
      className: "ps-4 text-center",
      cellClassName: "ps-4 text-center",
      style: { width: "100px" },
      render: (item) => (
        <div
          className="d-flex align-items-center justify-content-center border rounded bg-white overflow-hidden mx-auto"
          style={{ width: "45px", height: "30px", borderColor: "#eee" }}
        >
          {item.image ? (
            <img
              src={item.image}
              alt={item.label}
              style={{ width: "100%", height: "auto" }}
            />
          ) : (
            <div
              className="rounded-circle d-flex align-items-center justify-content-center fw-bold"
              style={{
                width: "20px",
                height: "20px",
                fontSize: "8px",
                backgroundColor: "#E2E8F0",
                color: "#64748B",
                border: "1px solid rgba(0,0,0,0.05)",
              }}
            >
              $
            </div>
          )}
        </div>
      ),
    },
    {
      label: "DENOMINATION",
      key: "label",
      style: { width: "250px" },
      render: (item) => (
        <span className="fs-13 fw-bold text-black">{item.label}</span>
      ),
    },
    {
      label: "INVENTORY",
      key: "inventory",
      className: "text-center",
      cellClassName: "text-center",
      style: { width: "150px" },
      render: (item) => (
        <div className="d-flex align-items-center justify-content-center">
          {item.inventory !== "-" && (
            <div
              className="rounded-circle me-1"
              style={{ width: "8px", height: "8px", backgroundColor: "#34D399" }}
            />
          )}
          <Badge
            bg="light"
            className="text-black fw-bold px-3 py-1 border rounded-pill"
            style={{ fontSize: "11px", backgroundColor: "#F9FAFB" }}
          >
            {item.inventory}
          </Badge>
        </div>
      ),
    },
    {
      label: "QUANTITY",
      key: "quantity",
      className: "text-center",
      cellClassName: "text-center",
      style: { width: "200px" },
      render: (item) => (
        <div className="d-flex justify-content-center">
          <input
            type="number"
            min="0"
            className="form-control text-center py-1"
            style={{
              height: "36px",
              width: "100px",
              fontSize: "13px",
              borderColor: "#CBD5E1",
              borderRadius: "8px",
            }}
            value={quantities[item.id] || ""}
            placeholder="0"
            onChange={(e) => handleQuantityChange(item.id, e.target.value)}
          />
        </div>
      ),
    },
    {
      label: "TOTAL",
      key: "total",
      className: "pe-4 text-end",
      cellClassName: "pe-4 text-end",
      style: { width: "180px" },
      render: (item) => (
        <div className="fw-bold fs-13 text-black">
          SGD {(item.value * (quantities[item.id] || 0)).toFixed(2)}
        </div>
      ),
    },
  ];

  return (
    <div className="mt-3">
      {/* Customer Header Info */}
      <div className="bg-white rounded-4 shadow-sm p-4 mb-4 border border-light">
        <div className="d-flex align-items-center">
          <span className="text-muted fs-13 me-3">Customer:</span>
          <span className="fw-bold text-black fs-14 me-4">
            {customer ? customer.name : "Quang Nguyen"}
          </span>
          <span className="text-muted fs-13 ms-3 me-3">Current balance:</span>
          <span className="fw-bold text-black fs-14">111,717 SGD</span>
        </div>
      </div>

      <div className="d-flex justify-content-end gap-2 mb-3">
        <Badge
          bg="light"
          className="text-black border px-3 py-2 d-flex align-items-center"
          style={{
            borderRadius: "20px",
            fontSize: "12px",
            backgroundColor: "#F1F5F9",
            borderColor: "#E2E8F0",
            height: "40px",
          }}
        >
          <span className="text-muted me-2">Total cash:</span>
          <span className="fw-bold" style={{ color: "#1E40AF" }}>
            SGD 111,517
          </span>
        </Badge>
        <Badge
          bg="light"
          className="text-black border px-3 py-2 d-flex align-items-center"
          style={{
            borderRadius: "20px",
            fontSize: "12px",
            backgroundColor: "#F1F5F9",
            borderColor: "#E2E8F0",
            height: "40px",
          }}
        >
          <span className="text-muted me-2">Total Top Up:</span>
          <span className="fw-bold" style={{ color: "#1E40AF" }}>
            SGD {totalTopUp.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 2 })}
          </span>
        </Badge>
      </div>

      <div className="card border-0 shadow-sm rounded-4 overflow-hidden border border-light">
        <DataTable
          columns={columns}
          data={denominations}
          showPagination={false}
          minWidth="100%"
        />
      </div>
    </div>
  );
};

export default EnterDenominations;
